export const INIT_CARTO = 'INIT_CARTO'
export const LOAD_MAP = 'LOAD_MAP'

export const LOAD_LAYER = 'LOAD_LAYER'
export const LOAD_DATAVIEW = 'LOAD_DATAVIEW'
export const ADD_POPUP = 'ADD_POPUP'
export const RESET_LAYERS = 'RESET_LAYERS'
export const ADD_TO_MAP = 'ADD_TO_MAP'
export const TOGGLE_LAYER = 'TOGGLE_LAYER'

export const LOAD_LAYERS = 'LOAD_LAYERS'
export const APPLY_FILTER = 'APPLY_FILTER'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
